<script setup>
import { computed } from 'vue'
import { useOrderStore } from '../../../../store/orderStore'
import { useDestinationStore } from '../../../../store/destinationStore'
import { usePlanStore } from '../../../../store/planStore'
import { usePeriodStore } from '../../../../store/periodStore'

const destinationStore = useDestinationStore();
const orderStore = useOrderStore();
const planStore = usePlanStore();
const periodStore = usePeriodStore();

const isShowMonthType = computed(() => {
    let value = false;
    const availableCountryIds = destinationStore.getMonthPlanDestinationApiIds;
    const selectedDestinations = destinationStore.getSelectedDestinations;
    const firstSelectedCountry = selectedDestinations.length ? selectedDestinations[0] : null;
    const isNotMultiDestination = !destinationStore.isMultiDestinationEnabled;
    const includesMonthPlanCountry = firstSelectedCountry && isNotMultiDestination && availableCountryIds.includes(firstSelectedCountry.api_country_id);

    if (includesMonthPlanCountry) {
        value = true;
    }

    return value;
});

function changePlanType(type) {
    planStore.setPlanType({type})
    
    if (type === 'month') {
        periodStore.setEndDateByMonthCount(0);
    }
}
</script>

<template>
    <div class="bg-white mb-2">
        <div class="purchase-rent-plan__switcher rounded-md border-2 border-sky-400 p-1 flex justify-between">
            <div 
                class="rounded-md text-center font-medium flex items-center justify-center cursor-pointer bg-white h-15 w-1/2 hover:text-sky-400"
                :class="`${planStore.plan_type === 'day' ? 'bg-sky-400! text-white hover:text-white' : ''} ${!isShowMonthType ? 'w-full' : ''}`"
                @click="changePlanType('day')"
            >
                {{ $t("purchase-rent-page.plans.dayPlans") }}
            </div>
            <div 
                v-if="isShowMonthType" 
                class="rounded-md text-center font-medium flex items-center justify-center cursor-pointer bg-white h-15 w-1/2 hover:text-sky-400"
                :class="`${planStore.plan_type === 'month' ? 'bg-sky-400! text-white hover:text-white' : ''}`" 
                @click="changePlanType('month')"
            >
                {{ $t("purchase-rent-page.plans.monthPlans") }}
            </div>
        </div>
    </div>
</template>

<style lang="scss">
</style>